module.exports = __webpack_public_path__ + "static/Mambu_homepage_January2019-16efa8fb5e998bbe289526b6d53459d5.webp";